import React from 'react';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
  fullScreen?: boolean;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  fullScreen = false,
  text
}) => {
  const sizeClasses = {
    xs: 'h-3 w-3 border',
    sm: 'h-4 w-4 border',
    md: 'h-6 w-6 border-2',
    lg: 'h-8 w-8 border-2',
    xl: 'h-16 w-16 border-4',
    '2xl': 'h-24 w-24 border-[6px]',
  };

  const spinner = (
    <div className="flex flex-col items-center gap-4">
      <div
        className={`animate-spin rounded-full border-t-sage-green border-r-transparent border-b-sage-green border-l-transparent ${sizeClasses[size]} ${className}`}
      />
      {text && (
        <p className="text-sage-green font-medium text-lg animate-pulse">
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-warm-white to-sage-mist z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
}; 